import { makeStyles } from "@material-ui/core"
import { themeColors } from "letalkui"

const useStyles = makeStyles(() => ({
	loadingContainer: {
		padding: "48px 24px",
		textAlign: "center"
	},
	spinnerContainer: {
		position: "relative",
		display: "inline-flex",
		alignItems: "center",
		justifyContent: "center",
		width: "100px",
		height: "100px",
		borderRadius: "50%",
		backgroundColor: themeColors.colors.system.purple[100]
	},
	spinnerLetter: {
		position: "absolute",
		fontSize: "2rem",
		fontWeight: 700,
		color: themeColors.colors.system.purple[600]
	},
	loadingTitle: {
		fontSize: "1.125rem",
		fontWeight: 600,
		color: themeColors.colors.system.gray[900],
		marginTop: "16px"
	},
	loadingSubtitle: {
		fontSize: "0.875rem",
		color: themeColors.colors.system.gray[500],
		marginTop: "8px"
	},
	loadingMessage: {
		fontSize: "0.875rem",
		fontWeight: 500,
		color: themeColors.colors.system.purple[600],
		marginTop: "16px"
	}
}))

export default useStyles
